import { Button, Flex, Markdowned, Modal } from '@raskrask-dk/rr-components'
import { t } from 'i18next'

export interface ICancelBookModalProps {
    shouldPayCancellationFee: boolean
    numberOfHoursUntillServiceDate: number
    showCancelBookModal: boolean
    setShowCancelBookingModal: (val: boolean) => void
    onClickCancelBooking: () => void
}

export const CancelBookingModal = ({
    numberOfHoursUntillServiceDate,
    shouldPayCancellationFee,
    showCancelBookModal,
    setShowCancelBookingModal,
    onClickCancelBooking,
}: ICancelBookModalProps): React.ReactFragment => {
    const cancellationFeeSize =
        numberOfHoursUntillServiceDate < 6
            ? 100
            : numberOfHoursUntillServiceDate > 6 &&
              numberOfHoursUntillServiceDate < 24
            ? 50
            : 0
    const dynamicCancellationFeeExplanationText =
        cancellationFeeSize === 50
            ? t('cancellationfee.50percent.explanation.text')
            : cancellationFeeSize === 100
            ? t('cancellationfee.100percent.explanation.text')
            : ''

    const cancellationFeeComponent = (
        <Flex direction={'column'} gap={'8'}>
            <Markdowned text={t('cancelbook.confirmcancellation')} />
            <Flex data-cy={`${cancellationFeeSize}feeexplanation`}>
                <Markdowned text={dynamicCancellationFeeExplanationText} />
            </Flex>
        </Flex>
    )

    const defaultTextElement = () => {
        return (
            <Markdowned text={t('cancelbook_confirmationmodal_defaulttext')} />
        )
    }

    return (
        <Modal style={{ width: '80%' }} open={showCancelBookModal}>
            <Flex direction={'column'} gap={'16'}>
                <Flex direction={'column'} gap={'16'}>
                    {shouldPayCancellationFee ? (
                        cancellationFeeComponent
                    ) : (
                        <></>
                    )}
                    {defaultTextElement()}
                </Flex>
                <Flex direction={'row'} gap={'8'} justifyContent={'center'}>
                    <Button
                        variant={'danger'}
                        data-cy={'ModalCancelbookingButton'}
                        onClick={() => onClickCancelBooking()}
                    >
                        {t('cancelbooking.button.text')}
                    </Button>
                    <Button
                        variant={'default'}
                        onClick={() => setShowCancelBookingModal(false)}
                    >
                        {t('cancelbooking.gobackbutton.text')}
                    </Button>
                </Flex>
            </Flex>
        </Modal>
    )
}
